module.exports = __webpack_public_path__ + "24e004ab/img/delete-icon.eb7de062.svg";